import React from 'react';

const PriceProgressBarSkeleton = () => {
  return (
    <div className="w-full mt-4 mb-8 max-w-xs animate-pulse">
      {/* Skeleton for the transaction header with prices and change percentage */}
      <div className="flex justify-start items-center mb-2">
        {/* Simulated price */}
        <div className="h-7 bg-gray-200 rounded w-20 mr-2"></div>
        {/* Simulated percentage */}
        <div className="h-5 bg-gray-200 rounded w-12"></div>
      </div>
      {/* Skeleton for the progress bar */}
      <div className="bg-gray-200 rounded-full h-4 overflow-hidden">
        <div className="h-full bg-gray-200" style={{ width: '50%' }}></div>
      </div>
      {/* Skeleton for the footer with min, average, and max prices */}
      <div className="flex justify-between text-xs mt-2">
        <div className="h-5 bg-gray-200 rounded w-12"></div>
        <div className="h-5 bg-gray-200 rounded w-12"></div>
        <div className="h-5 bg-gray-200 rounded w-12"></div>
      </div>
    </div>
  )
}

export default PriceProgressBarSkeleton;
